import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { h300, h400, h700 } from '@atlaskit/theme/typography';
import MarkAllAsReadButton from '../../../common/ui/mark-all-as-read';
import ToggleReadState from '../../../common/ui/toggle-read-state';
import messages from '../../../common/utils/i18n/messages';
import HeaderDropdownMenu from './dropdown-menu';
import FPNLink from './fpn-link';
import { InboxLink } from './inbox-link';
import { GroupingText, HeaderText, HeaderWrapper, MarkAsReadWrapper, StickyHeader, StickyHeaderText } from './styled';
import { resolveCategoryMessage } from './utils';
export var Header = function Header(_ref) {
  var headerStickyTop = _ref.headerStickyTop,
    readStateFilter = _ref.readStateFilter,
    requestCategory = _ref.requestCategory,
    toggleReadStateFilter = _ref.toggleReadStateFilter,
    groupingHeader = _ref.groupingHeader,
    isSticky = _ref.isSticky,
    handleMarkAllNotificationsRead = _ref.handleMarkAllNotificationsRead,
    isMarkAllAsReadVisible = _ref.isMarkAllAsReadVisible,
    spacing = _ref.spacing,
    toggleGroupedNotificationsView = _ref.toggleGroupedNotificationsView,
    isGroupedNotificationsViewOn = _ref.isGroupedNotificationsViewOn,
    _ref$fullPageNotifica = _ref.fullPageNotificationBranding,
    fullPageNotificationBranding = _ref$fullPageNotifica === void 0 ? 'full-page' : _ref$fullPageNotifica,
    _ref$shouldPlayInboxA = _ref.shouldPlayInboxAnnouncementAnimation,
    shouldPlayInboxAnnouncementAnimation = _ref$shouldPlayInboxA === void 0 ? false : _ref$shouldPlayInboxA,
    FullPageButton = _ref.FullPageButton;
  var renderFullPageLink = function renderFullPageLink() {
    if (FullPageButton) {
      return /*#__PURE__*/React.createElement(FullPageButton, null);
    }
    switch (fullPageNotificationBranding) {
      case 'inbox':
        return /*#__PURE__*/React.createElement(InboxLink, {
          shouldPlayAnnouncementAnimation: shouldPlayInboxAnnouncementAnimation
        });
      case 'full-page':
      default:
        return /*#__PURE__*/React.createElement(FPNLink, null);
    }
  };
  var renderStickyHeader = function renderStickyHeader() {
    return /*#__PURE__*/React.createElement(StickyHeader, {
      spacing: spacing,
      top: headerStickyTop,
      "data-testid": "notifications-sticky-header"
    }, /*#__PURE__*/React.createElement(GroupingText, {
      mixin: h300
    }, " ", groupingHeader, " "), /*#__PURE__*/React.createElement(StickyHeaderText, {
      mixin: h400
    }, /*#__PURE__*/React.createElement(FormattedMessage, resolveCategoryMessage(requestCategory))), /*#__PURE__*/React.createElement(MarkAsReadWrapper, null, isMarkAllAsReadVisible ? /*#__PURE__*/React.createElement(MarkAllAsReadButton, {
      handleMarkAllNotificationsRead: handleMarkAllNotificationsRead
    }) :
    /*#__PURE__*/
    // Render content so the notification text stays centered
    React.createElement("span", null)));
  };
  if (isSticky) {
    return renderStickyHeader();
  }
  return /*#__PURE__*/React.createElement(HeaderWrapper, {
    spacing: spacing
  }, /*#__PURE__*/React.createElement(HeaderText, {
    mixin: h700,
    id: "notification-list-header-label"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.notifications)), /*#__PURE__*/React.createElement(ToggleReadState, {
    readStateFilter: readStateFilter,
    toggleReadStateFilter: toggleReadStateFilter
  }), renderFullPageLink(), toggleGroupedNotificationsView !== undefined && /*#__PURE__*/React.createElement(HeaderDropdownMenu, {
    isGroupedNotificationsViewOn: isGroupedNotificationsViewOn,
    toggleGroupedNotificationsView: toggleGroupedNotificationsView,
    markAllNotificationsRead: handleMarkAllNotificationsRead,
    isMarkAllAsReadVisible: isMarkAllAsReadVisible
  }));
};